import { TB_PAGINATED } from '../utils/constants';

// Task detail routes are directly included in this file
export default [
    {
        path: '/financialclose',
        component: "__base",
        otherdata: { color: "caccounting" },
        children: [
            {
                path: "home",
                component: "Cycles/Cycles.vue",
                meta: { title: "Home" },
                right: "financialclose_project"
            },
            {
                path: "homeview",
                component: "HomeView.vue",
                meta: { title: "Cycle List" },
                right: "financialclose_project"
            },
            {
                path: "project/dashboard/:id",
                component: "Project/Dashboard.vue",
                meta: { title: "Dashboard", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/checklist/:id",
                component: "Project/TasksLandingPage.vue",
                meta: { title: "Tasks", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/checklist/:projectId/task/:taskId",
                component: "Project/TaskDetail/TaskDetail.vue",
                meta: { title: "Task Detail" },
                right: "financialclose_analysis",
            },
            {
                path: "project/trialbalance/:id",
                component: TB_PAGINATED.ENABLED
                    ? "Project/TrialBalance/TrialBalancePaginated.vue"
                    : "Project/TrialBalance/TrialBalance.vue",
                meta: { title: "Trial Balance", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/cycle-settings/:id",
                component: "Project/CycleSettings/CycleSettings.vue",
                meta: { title: "Cycle Settings", submenu: ["tabs"] },
                right: "financialclose_analysis",
                redirect: (to) => ({
                    path: `/financialclose/project/cycle-settings/${to.params.id}/team`,
                    query: to.query
                }),
                children: [
                    {
                        path: "team",
                        component: "Project/User.vue",
                        meta: { title: "Cycle Settings — Team", embeddedInCycleSettings: true },
                        right: "financialclose_analysis"
                    },
                    {
                        path: "threshold",
                        component: "Project/Threshold.vue",
                        meta: { title: "Cycle Settings — Threshold", embeddedInCycleSettings: true },
                        right: "financialclose_analysis"
                    },
                    {
                        path: "automations",
                        component: "Project/CycleSettings/CycleAutomations/CycleAutomations.vue",
                        meta: { title: "Cycle Settings — Automations", embeddedInCycleSettings: true },
                        right: "financialclose_analysis"
                    }
                ]
            },
            {
                path: "project/users/:id",
                redirect: (to) => ({
                    path: `/financialclose/project/cycle-settings/${to.params.id}/team`,
                    query: to.query
                })
            },
            {
                path: "project/threshold/:id",
                redirect: (to) => ({
                    path: `/financialclose/project/cycle-settings/${to.params.id}/threshold`,
                    query: to.query
                })
            },
            {
                path: "project/informationmanager/:id",
                component: "Project/InformationManager/InformationManager.vue",
                meta: { title: "Information Manager", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/informationrequests/:id",
                component: "Project/InformationRequests/InformationRequests.vue",
                meta: { title: "Information Requests", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/informationmanager/:id/request/:requestId",
                component: "Project/InformationRequests/InformationRequestDetail.vue",
                meta: { title: "Information Request Detail" },
                right: "financialclose_analysis"
            },
            {
                path: "project/informationrequests/:id/request/:requestId",
                component: "Project/InformationRequests/InformationRequestDetail.vue",
                meta: { title: "Information Request Detail" },
                right: "financialclose_analysis"
            },
            {
                path: "project/varianceanalysis/:id",
                component: "VarianceAnalysis/List.vue",
                meta: { title: "Variance Analysis", submenu: ["tabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "functionalsupport/:id",
                component: "VirtualConcierge.vue",
                meta: { title: "Virtual Concierge", right: "helpdesk", submenu: ["tabs"]}, 
            },
            {
                path: "functionalsupport/:id/support/:QueryId",
                component: "common/QueriesView.vue",
                meta: { title: "Ticket Details", right: "helpdesk", submenu: ["tabs"]},
            },
            {
                path: "automationaccruals/:id",
                component: "Automation/Accruals/Accruals.vue",
                meta: { title: "Accruals", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationaccruals/:id/data",
                component: "Automation/Accruals/AccrualsData.vue",
                meta: { title: "Accruals Data", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationaccruals/:id/estimates",
                component: "Automation/Accruals/AccrualsEstimates.vue",
                meta: { title: "Accruals Estimates", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationaccruals/:id/configuration",
                component: "Automation/Accruals/AccrualsConfiguration.vue",
                meta: { title: "Accruals Configuration", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationaccruals/:id/ingestion",
                redirect: (to) => ({
                    path: `/financialclose/automationaccruals/${to.params.id}/source`,
                    query: to.query,
                }),
            },
            {
                path: "automationaccruals/:id/source",
                component: "Automation/AccrualsIngestion.vue",
                meta: { title: "Accruals Source Upload", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationlease/:id",
                component: "Automation/LeaseSchedule.vue",
                meta: { title: "Lease Schedule", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationborrowingschedule/:id",
                component: "Automation/BorrowingSchedule.vue",
                meta: { title: "Borrowing Schedule", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationtransactionmatching/:id",
                component: "Automation/TransactionMatching.vue",
                meta: { title: "Transaction Matching", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automationtransactionmatching/:id/c/:anaid",
                component: "Automation/TransactionMatchingConfig.vue",
                meta: { title: "Transaction Matching", right: "financialclose_analysis", submenu: ["tabs"]},
            },
            {
                path: "automation/riskmanagementhome/:id",
                component: "Automation/RiskmanagementHome.vue",
                meta: { title: "Risk Management", right: "financialclose_analysis", submenu: ["tabs"]},        
            },
            {
                path: "automation/riskmanagementbotview/:botID",
                component: "Automation/Riskmanagementbotview.vue",
                meta: { title: "Risk Management view", right: "financialclose_analysis" ,submenu: ["tabs"]},
            },
            {
                path: "project/:id/varianceanalysis/analysis/:vid",
                component: "VarianceAnalysis/Analysis.vue",
                meta: { title: "Variance Analysis", submenu: ["tabs", "vatabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/:id/varianceanalysis/configuration/:vid",
                component: "VarianceAnalysis/Configuration.vue",
                meta: { title: "Variance Analysis - Configuration", submenu: ["tabs", "vatabs"] },
                right: "financialclose_analysis"
            },
            {
                path: "project/:id/varianceanalysis/users/:vid",
                component: "VarianceAnalysis/User.vue",
                meta: { title: "Variance Analysis - Users", submenu: ["tabs", "vatabs"] },
                right: "financialclose_analysis"
            },
            // Setup routes (NXTGEN-5822)
            {
                path: "setup/location",
                component: "Setup/Location/Location.vue",
                meta: { title: "Location", edit: true },
                right: "financialclose_master_checklist"
            },
            {
                path: "setup/chartofaccount",
                component: "Setup/ChartOfAccount/ChartOfAccount.vue",
                meta: { title: "Chart of Accounts" },
                right: "financialclose_master_chartofaccount"
            },
            {
                path: "setup/tasklist",
                name: "fc-setup-tasklist",
                component: "Setup/TaskList/TaskList.vue",
                meta: { title: "Task Library" },
                right: "financialclose_master_checklist"
            },
            {
                path: "setup/users",
                name: "fc-setup-users",
                component: "Setup/User/User.vue",
                meta: { title: "Users" },
                right: "financialclose_master_user_management"
            },
            {
                // Param route must stay registered for Task Library → Task Detail navigation.
                path: "setup/tasklist/:id",
                name: "fc-setup-task-detail",
                component: "Setup/TaskDetail/TaskDetail.vue",
                meta: { title: "Task Template Detail" },
                right: "financialclose_master_checklist"
            },
            {
                path: "setup/informationmanager",
                component: "Setup/InformationManager/InformationManager.vue",
                meta: { title: "Information Manager" },
                right: "financialclose_master_informationmanager"
            },
            {
                path: "setup/emailnotifications",
                component: "Setup/EmailNotifications/EmailNotifications.vue",
                meta: { title: "Automations" },
                right: "financialclose_notification_management"
            },
            {
                path: "manage/financialstatementpreparation/:id",
                component: "Setup/FinancialstatementPreparation.vue",
                meta: { title: "FS preparation" },
                right: "financialclose_master_checklist",
                class: 'noTransform'

            },
            {
                path: "support", 
                component: "TechnicalSupport.vue",
                meta: { title: "Support", right: "helpdesk"}, 
            },
            {
                path: "chat", 
                component: "ChatBot.vue",
                meta: { title: "Chatbot", right: "helpdesk"}, 
            },
            {
                path: "support/:QueryId",
                component: "common/QueriesView.vue",
                meta: { title: "Ticket Details", right: "helpdesk"},
            },
            {
                path: "*",
                component: "",
            },
        ],
    },
]

